(function IIFE() {
    'use strict';

    /////////////////////////////

    function RssFactory($resource, Config) {
        'ngInject';

        return $resource(Config.HAUSSMANN_HOST + '/_ah/api/lumsites/v1/content/rss/:methodKey', {}, {
            getRssContent: {
                isArray: false,
                method: 'GET',
                params: {
                    methodKey: 'get',
                },
            },
        });
    }

    /////////////////////////////

    angular.module('Factories').factory('RssFactory', RssFactory);
})();
